import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from "react-router-dom";
const RouterNavLink = ({ className = "", children, onClick, to, }) => {
    return (_jsx(Link, Object.assign({ className: `nav-link ${className}`, style: { cursor: "pointer" }, to: to }, (onClick && { onClick: onClick }), { children: children })));
};
export default RouterNavLink;
